document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('subcollections-root');
  if (!root) return;

  const rootPreloader = root.querySelector('p');

  const domain = root.dataset.domain;
  const token = root.dataset.token;
  const parentHandle = (root.dataset.parentHandle || '').trim().toLowerCase();
  const parentTitle = root.dataset.parentTitle || '';

  const mainNs = root.dataset.mainMetafieldNamespace;
  const mainKey = root.dataset.mainMetafieldKey;
  const typeNs = root.dataset.typeMetafieldNamespace;
  const typeKey = root.dataset.typeMetafieldKey;

  if (!domain || !token) {
    if (rootPreloader) rootPreloader.textContent = 'Storefront API error.';
    return;
  }

  const endpoint = `https://${domain}/api/2024-07/graphql.json`;

  const query = `
    query CollectionsWithSubcategories($cursor: String) {
      collections(first: 200, after: $cursor) {
        edges {
          cursor
          node {
            id
            handle
            title
            onlineStoreUrl
            mainCollectionMetafield: metafield(namespace: "${mainNs}", key: "${mainKey}") {
              reference {
                ... on Collection {
                  handle
                }
              }
            }
            typeMetafield: metafield(namespace: "${typeNs}", key: "${typeKey}") {
              value
            }
          }
        }
        pageInfo { hasNextPage }
      }
    }
  `;

  function extractCollectionHandleFromHref(href) {
    if (!href) return '';

    try {
      const url = new URL(href, window.location.origin);
      const path = url.pathname || '';
      const match = path.match(/\/collections\/([^\/?#]+)/i);
      return match && match[1] ? String(match[1]).trim().toLowerCase() : '';
    } catch (e) {
      const match = String(href).match(/\/collections\/([^\/?#]+)/i);
      return match && match[1] ? String(match[1]).trim().toLowerCase() : '';
    }
  }

  function collectExcludedHandlesFromDom() {
    const selectors = [
      '.collections-list__main a.collections-list-main-slide',
      '.collections-list-secondary a.btn--secondary',
      '.collections-list__main a[href*="/collections/"]',
      '.collections-list-secondary a[href*="/collections/"]',
    ];

    const set = new Set();

    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(link => {
        const handle = extractCollectionHandleFromHref(link.getAttribute('href') || link.href);
        if (handle) set.add(handle);
      });
    });

    return set;
  }

  async function fetchAllCollections() {
    let cursor = null;
    let hasNextPage = true;
    const all = [];

    while (hasNextPage) {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token,
        },
        body: JSON.stringify({
          query,
          variables: { cursor },
        }),
      });

      if (!res.ok) {
        throw new Error('Storefront API error: ' + res.status);
      }

      const json = await res.json();

      if (json.errors) {
        console.error(json.errors);
        throw new Error('GraphQL errors');
      }

      const data = json.data.collections;

      data.edges.forEach(edge => {
        all.push(edge.node);
        cursor = edge.cursor;
      });

      hasNextPage = data.pageInfo.hasNextPage;
    }

    return all;
  }

  function filterByParent(col) {
    const ref = col.mainCollectionMetafield && col.mainCollectionMetafield.reference;
    const handle = ref && ref.handle ? String(ref.handle).trim().toLowerCase() : '';
    return handle === parentHandle;
  }

function splitByType(children) {
  const noType = [];
  const typed = new Map();

  children.forEach(col => {
    let title = col.title || '';

    if (
      title &&
      parentTitle &&
      title !== parentTitle &&
      title.indexOf(parentTitle) === 0
    ) {
      title = title.slice(parentTitle.length).trim();
    }

    const url = col.onlineStoreUrl || `/collections/${col.handle}`;

    const item = {
      handle: String(col.handle || '').trim().toLowerCase(),
      title: title || col.title || '',
      url,
    };

    const typeVal =
      col.typeMetafield && col.typeMetafield.value
        ? col.typeMetafield.value.trim()
        : '';

    if (!typeVal) {
      noType.push(item);
    } else {
      if (!typed.has(typeVal)) typed.set(typeVal, []);
      typed.get(typeVal).push(item);
    }
  });

  // сортировка
  noType.sort((a, b) =>
    a.title.localeCompare(b.title, undefined, { sensitivity: 'base' })
  );

  typed.forEach(arr => {
    arr.sort((a, b) =>
      a.title.localeCompare(b.title, undefined, { sensitivity: 'base' })
    );
  });

  return { noType, typed };
}

  function buildHtml(children) {
    const { noType, typed } = splitByType(children);

    let html = '<div class="list-categories">';

    if (noType.length > 0) {
      html += `
        <div class="list-categories__wrapp">
          <div class="list-categories__group">
            <div class="list-categories__items">
      `;

      noType.forEach(item => {
        html += `
              <a class="list-item" href="${item.url}">
                ${item.title}
              </a>
        `;
      });

      html += `
            </div>
          </div>
        </div>
      `;
    }

    if (typed.size > 0) {
      html += `<div class="list-categories__wrapp has-types">`;

      const priority = ['Gender', 'Frame Shape', 'Frame Materials'];
      const keys = Array.from(typed.keys());

      keys.sort((a, b) => {
        const aIndex = priority.indexOf(a);
        const bIndex = priority.indexOf(b);

        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
        if (aIndex !== -1) return -1;
        if (bIndex !== -1) return 1;
        return String(a).localeCompare(String(b));
      });

      keys.forEach(typeName => {
        if (!typeName) return;

        const items = typed.get(typeName) || [];
        if (!items.length) return;

        html += `
          <div class="list-categories__group">
            <div class="list-categories__title">
              <h5>${typeName}</h5>
            </div>
            <div class="list-categories__items">
        `;

        items.forEach(item => {
          html += `
              <a class="list-item" href="${item.url}">
                ${item.title}
              </a>
          `;
        });

        html += `
            </div>
          </div>
        `;
      });

      html += `</div>`;
    }

    html += '</div>';
    return html;
  }

  async function init() {
    try {
      if (rootPreloader) {
        rootPreloader.textContent = 'Loading...';
      }

      const excludedHandles = collectExcludedHandlesFromDom();
      const allCollections = await fetchAllCollections();

      const childrenRaw = allCollections.filter(filterByParent);

      console.log(
        '[subcollections] children before exclude:',
        childrenRaw.map(c => c.handle)
      );

      const children = childrenRaw.filter(col => {
        const handle = String(col.handle || '').trim().toLowerCase();
        return handle && !excludedHandles.has(handle);
      });

      console.log(
        '[subcollections] children after exclude:',
        children.map(c => c.handle)
      );

      if (!children.length) {
        if (rootPreloader && root.contains(rootPreloader)) {
          rootPreloader.remove();
        } else {
          root.innerHTML = '';
        }
        return;
      }

      root.innerHTML = buildHtml(children);
    } catch (e) {
      console.error(e);
      if (rootPreloader) {
        rootPreloader.textContent = 'Loading Error.';
      }
    }
  }

  init();
});